module.exports = __webpack_public_path__ + "static/media/poly.944c729b.glb";